import { Injectable } from '@angular/core';
import { EMPTY, Observable, defer, filter, repeat, retry, timer } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

const RECONNECT_MS = 5000;
// Pasados estos fallos seguidos el error llega al consumidor: charger y diagnosis lo usan para avisar de la desconexión.
const MAX_RETRIES = 3;

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private myWebSocket: WebSocketSubject<any> | null = null;
  private session: object | null = null;

  constructor(private _auth: AuthService) { }

  public connect(serial: string): Observable<any> {
    // La URL se construye en cada (re)conexión para usar el token vigente: AuthService lo renueva antes de caducar.
    return this.open(() => environment.socketServer + '/' + serial + '?token=' + this._auth.userToken);
  }

  public connectByUrl(url: string): Observable<any> {
    return this.open(() => url);
  }

  private open(buildUrl: () => string): Observable<any> {
    this.close();
    const session = {};
    this.session = session;
    const active = () => this.session === session;
    const reconnect = () => active() ? timer(RECONNECT_MS) : EMPTY;

    return defer(() => {
      // Un timer de reconexión de una sesión ya cerrada no debe pisar el socket de la actual.
      if (!active()) return EMPTY;
      // Un frame no-JSON rompía el deserializador y cerraba la suscripción en silencio: se descarta.
      this.myWebSocket = webSocket({ url: buildUrl(), deserializer: e => { try { return JSON.parse(e.data); } catch { return null; } } });
      return this.myWebSocket;
    }).pipe(
      filter(msg => msg !== null),
      retry({ count: MAX_RETRIES, delay: reconnect, resetOnSuccess: true }),
      repeat({ delay: reconnect }),
    );
  }

  close() {
    this.session = null;
    const ws = this.myWebSocket;
    this.myWebSocket = null;
    ws?.complete();
  }

}
